export default __webpack_public_path__ + "static/media/game_stats.06b968f5.png";